import React from "react";
import { FormattedMessage } from "react-intl";

import BarSorting from "../../components/Task/types/BarSorting";
import BarSorting2 from "../../components/Task/types/BarSorting2";
import Barline from "../../components/Task/types/Barline";
import RhytSorting from "../../components/Task/types/RhytSorting";
import MelodyTable from "../../components/Task/types/MelodyTable";
import TonesetStaff from "../../components/Task/types/TonesetStaff";
import Flow from "../../components/Task/types/Flow";
import Singing from "../../components/Task/types/Singing";
import RhytName from "../../components/Task/types/RhytName";
import RhytKnock from "../../components/Task/types/RhytKnock";
import RhytNotation from "../../components/Task/types/RhytNotation";
import SolfaName from "../../components/Task/types/SolfaName";
import HandSign from "../../components/Task/types/HandSign";
import Intervals from "../../components/Task/types/Intervals";
import Piano from "../../components/Task/types/Piano";
import Embed from "../../components/Task/types/Embed";
import Chords3 from "../../components/Task/types/Chords3";
import SubScore from "../../components/Task/types/SubScore";

import messages from "./messages";

export default (taskType: string) => {
    switch (taskType) {
        case "barSorting":
            return BarSorting;
        case "barSorting2":
            return BarSorting2;
        case "barline":
            return Barline;
        case "embed":
            return Embed;
        case "rhytSorting":
            return RhytSorting;
        case "melodyTable":
            return MelodyTable;
        case "tonesetStaff":
            return TonesetStaff;
        case "flow":
            return Flow;
        case "singing":
            return Singing;
        case "rhytName":
            return RhytName;
        case "rhytKnock":
            return RhytKnock;
        case "subScore":
            return SubScore;
        case "rhytNotation":
            return RhytNotation;
        case "solfaName":
            return SolfaName;
        case "handSign":
            return HandSign;
        case "intervals":
            return Intervals;
        case "chords3":
            return Chords3;
        case "piano":
            return Piano;
        default:
            return () => (
                <div>
                    <FormattedMessage {...messages.unknown} />
                </div>
            );
    }
}